module.exports = __webpack_public_path__ + "static/media/StudentLogo.6a023403.png";